import {useEffect, useState} from "react";
import {useGetCatgeory} from "../../../hooks/useCategory";
import {useMe} from "../../../hooks/useGetUser";
import Loader from "../shared/Loader";
import SubCategoryDrop from "./SubCategory";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";
import useUserSectors from "../../../hooks/useUsersSectors";
import {baseImageUrl} from "../../../services/AxiosInstance";
import PrestationItem from "./PrestationItem";

const ProfileExpertise = ({anonymeData}) => {
  const [selectedCat, setSelectedCat] = useState([]);
  // const {data, isLoading} = useMe();
  // const {data: categories, isLoading: isLoadingCategory} = useGetCatgeory();
  const {subCategories, categories, sectors, isLoading} =
    useUserSectors(anonymeData);
  // useEffect(() => {
  //   const subCategories = data?.Technician?.SubCategories;
  //   if (!!subCategories?.length && !!categories?.length) {
  //     subCategories.map((ele) => {
  //       let categoryObject = categories.find(
  //         (category) => category.id === ele.fatherId
  //       );
  //       if (categoryObject)
  //         setSelectedCat((prev) => {
  //           let set = new Set([...prev, categoryObject]);
  //           return Array.from(set.values());
  //         });
  //     });
  //   }
  // }, [data, categories]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="w-full px-1 py-11 flex flex-col gap-5 justify-start items-start">
      <div className="text-left font-bold text-xl text-[#19295C] mb-2  ">
        Compétences
      </div>
      {!!subCategories?.length ? (
        <>
          <div className="w-full flex flex-col gap-7 justify-start items-start">
            {!!sectors?.length &&
              sectors.map((ele) => (
                <PrestationItem
                  sector={ele}
                  subCategories={subCategories}
                  key={ele.id}
                />
              ))}
          </div>
          {/* <div className="w-full flex flex-col gap-3 justify-start items-start">
            <div className="text-left font-semibold text-base text-[#7e7e7e]">
              {!!anonymeData ? "Catégories" : "Mes catégories"}
            </div>
            <div className="flex justify-start items-center flex-wrap gap-2">
              {!!categories?.length &&
                categories.map((ele) => (
                  <div
                    key={ele?.id}
                    className=" bg-gradient-to-r from-[#0022AA1A] to-[#1A64B91A] gap-2  font-bold text-sm  rounded-3xl px-4 py-2 flex justify-center items-center text-[#1A64B9] "
                  >
                    {ele.title}{" "}
                  </div>
                ))}
            </div>
          </div>
          <div className="w-full flex flex-col gap-3 justify-start items-start">
            <div className="text-left font-semibold text-base text-[#7e7e7e]">
              {!!anonymeData ? " Sous-Catégories" : "Mes sous-catégories"}
            </div>
            <div className="flex justify-start items-center flex-wrap gap-2">
              {!!subCategories?.length &&
                subCategories.map((ele) => (
                  <div
                    key={ele?.id}
                    className=" bg-gradient-to-r from-[#0022AA1A] to-[#1A64B91A] gap-2  font-bold text-sm  rounded-3xl px-4 py-2 flex justify-center items-center text-[#1A64B9] "
                  >
                    {ele.title}{" "}
                  </div>
                ))}
            </div>
          </div> */}
        </>
      ) : (
        <div className="text-base text-[#7e7e7e]">
          Pas de prestations indiquées
        </div>
      )}

      {/* <div className="flex justify-start items-center gap-2">
        {!!selectedCat.length &&
          selectedCat.map((ele) => (
            <div className=" bg-gradient-to-r from-[#0022AA1A] to-[#1A64B91A] gap-2  font-bold text-sm  rounded-3xl px-4 py-2 flex justify-center items-center text-[#1A64B9] ">
              {ele.title}{" "}
              <i
                className="fi fi-rr-cross-small flex justify-center items-center cursor-pointer"
                onClick={() => {
                  setSelectedCat((prev) => [
                    ...prev.filter((el) => el.id !== ele.id),
                  ]);
                }}
              ></i>
            </div>
          ))}
      </div> */}
    </div>
  );
};

export default ProfileExpertise;
